module.exports = __webpack_public_path__ + "img/btn-reservation-no.75a9ede3.png";